<template lang="pug">
v-col(:cols="setting.colSize || 6" v-if="!setting.hidden")
    template(v-if="setting.type === 'boolean'")
        .checkbox-wrapper
            v-checkbox(
                :label="setting.label"
                :input-value="getCheckboxValue(setting)"
                @change="onCheckboxChange($event, setting)"
                hide-details
                dense
            )
    template(v-else-if="setting.type === 'enum'")
        v-select(
            v-model="localSettings[setting.varKey]"
            :label="setting.label"
            :items="setting.enumValues"
            item-text="key"
            item-value="value"
            :hint="setting.hint"
            @change="onEnumChange(setting)"
            persistent-hint
        )
    template(v-else-if="setting.type === 'string'")
        v-text-field(
            v-model="localSettings[setting.varKey]"
            :label="setting.label"
            :hint="setting.hint"
            @change="onStringChange(setting)"
            persistent-hint
            dense
        )
    template(v-else-if="setting.type === 'title'")
        .text-h5 {{ setting.label }}
    
    template(v-if="setting.type === 'group-parent'")
        v-expansion-panels(accordian multiple v-model="panel")
            v-expansion-panel(v-for="(childSetting, childIndex) in setting.children" :key="childIndex")
                v-expansion-panel-header
                    .text-subtitle-2 {{ childSetting.label }}
                v-expansion-panel-content
                    v-row
                        CookieSettingItem(
                            v-for="(nestedSettings, nestedIndex) in childSetting.children"
                            :key="nestedIndex"
                            :setting="nestedSettings"
                            :local-settings="localSettings"
                            :cookie-settings-object="cookieSettingsObject"
                            @reactive-change="onReactiveChange"
                        )
</template>

<script lang="ts">
import Vue from 'vue';
import { CookieSettingsHelper } from '@/helpers/cookie';

export default Vue.extend({
    name: 'CookieSettingItem',
    data() {
        return {
            panel: [],
        };
    },
    props: {
        cookieSettingsObject: {
            type: Object,
            required: true,
        },
        localSettings: {
            type: Object,
            required: true,
        },
        setting: {
            type: Object as () => CookieSettingsHelper, // this syntax is because CookieSettingsHelper is an interface not a class
            required: true,
        },
    },
    methods: {
        getCheckboxValue(setting) {
            const val = this.localSettings[setting.varKey];
            return setting.isNegator ? !val : val;
        },
        onCheckboxChange(value, setting) {
            this.localSettings[setting.varKey] = setting.isNegator ? !value : value;
            
            if (setting.reactive) {
                this.$emit('reactiveChange', setting, this.localSettings[setting.varKey]);
            }
        },
        onEnumChange(setting) {
            if (setting.reactive) {
                this.$emit('reactiveChange', setting, this.localSettings[setting.varKey]);
            }
        },
        onStringChange(setting) {
            if (setting.reactive) {
                this.$emit('reactiveChange', setting, this.localSettings[setting.varKey]);
            }
        },
        onReactiveChange(setting, value) {
            this.$emit('reactiveChange', setting, value);
        },
    },
    components: {
    },
});
</script>

<style lang="scss" scoped>
.checkbox-wrapper {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
}
</style>
